import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs/Observable'

import { selectCampaignId } from '../selectors'

import { fetchTestCampaignResultsError, fetchTestCampaignResultsSuccess } from './actions'
import { FETCH_TEST_CAMPAIGN_RESULTS_ASYNC, SEND_TRY_IT_OUT_ASYNC } from './constants'

const fetchTestCampaignResultsEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$
    .ofType(FETCH_TEST_CAMPAIGN_RESULTS_ASYNC.INITIATE, SEND_TRY_IT_OUT_ASYNC.SUCCESS)
    .mergeMap(() =>
      api.wizardCampaign
        .getTestCampaignResults(selectCampaignId(store.getState()))
        .mergeMap((response) => Observable.of(fetchTestCampaignResultsSuccess(response)))
        .catch((error) =>
          Observable.of(epicsErrorHandler(fetchTestCampaignResultsError, error, [400]))
        )
    )

export default combineEpics(fetchTestCampaignResultsEpic)
